import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    Link,
    Button,
    Heading,
    Text,
    useColorModeValue,
  } from '@chakra-ui/react';
  import {Link as NavLink} from "react-router-dom"

import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../Redux/action';
import { Spinner } from "@chakra-ui/react"

  const initState={
    email:"",
    password:""
  }

  

  export default function Login() {
    const [formState,setFormState]=useState(initState)

const{authState}=useContext(AuthContext)

const handleChange=(e)=>{
  e.preventDefault()
  setFormState((prev)=>
  ({
    ...prev,
    [e.target.name]:e.target.value
  })

)
}

let Navigate=useNavigate()

const {loading} = useSelector(e=>e.auth)

let dispatch=useDispatch()

const handleSubmit= async(e)=>{
e.preventDefault()

try {
  let res = await dispatch(login(formState))
if(res.data.token){
  Navigate('/')
}else(
  alert("wrong credential!")
)
} catch (error) {
  console.log(error)
}
}



const{email,password}=formState

    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>Sign in to your account</Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              to enjoy all of our cool <Link color={'blue.400'}>features</Link> ✌️
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>Email address</FormLabel>
                <Input type="email" name='email' value={email} onChange={handleChange} />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password</FormLabel>
                <Input type="password" name='password' value={password} onChange={handleChange}  />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}>
                  <Checkbox>Remember me</Checkbox>
                  <NavLink  to="/signup">Don't have Account</NavLink>
                </Stack>
                <Button
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }} onClick={(e)=>handleSubmit(e)} >
                  {loading?<Spinner size='md'/>:"Sign in"}
                </Button>

                
              
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    );
  }